'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var multihashing = require('multihashing-async');

var protobuf = require('protons');

var bs58 = require('bs58');

var nextTick = require('async/nextTick');

var crypto = require('./rsa');

var pbm = protobuf(require('./keys.proto'));

require('node-forge/lib/sha512');

require('node-forge/lib/pbe');

var forge = require('node-forge/lib/forge');

var RsaPublicKey =
/*#__PURE__*/
function () {
  function RsaPublicKey(key) {
    _classCallCheck(this, RsaPublicKey);

    this._key = key;
  }

  _createClass(RsaPublicKey, [{
    key: "verify",
    value: function verify(data, sig, callback) {
      ensure(callback);
      crypto.hashAndVerify(this._key, sig, data, callback);
    }
  }, {
    key: "marshal",
    value: function marshal() {
      return crypto.utils.jwkToPkix(this._key);
    }
  }, {
    key: "encrypt",
    value: function encrypt(bytes) {
      return this._key.encrypt(bytes, 'RSAES-PKCS1-V1_5');
    }
  }, {
    key: "equals",
    value: function equals(key) {
      return this.bytes.equals(key.bytes);
    }
  }, {
    key: "hash",
    value: function hash(callback) {
      ensure(callback);
      multihashing(this.bytes, 'sha2-256', callback);
    }
  }, {
    key: "bytes",
    get: function get() {
      return pbm.PublicKey.encode({
        Type: pbm.KeyType.RSA,
        Data: this.marshal()
      });
    }
  }]);

  return RsaPublicKey;
}();

var RsaPrivateKey =
/*#__PURE__*/
function () {
  // key       - Object of the jwk format
  // publicKey - Buffer of the spki format
  function RsaPrivateKey(key, publicKey) {
    _classCallCheck(this, RsaPrivateKey);

    this._key = key;
    this._publicKey = publicKey;
  }

  _createClass(RsaPrivateKey, [{
    key: "genSecret",
    value: function genSecret() {
      return crypto.getRandomValues(16);
    }
  }, {
    key: "sign",
    value: function sign(message, callback) {
      ensure(callback);
      crypto.hashAndSign(this._key, message, callback);
    }
  }, {
    key: "decrypt",
    value: function decrypt(msg, callback) {
      crypto.decrypt(this._key, msg, callback);
    }
  }, {
    key: "marshal",
    value: function marshal() {
      return crypto.utils.jwkToPkcs1(this._key);
    }
  }, {
    key: "equals",
    value: function equals(key) {
      return this.bytes.equals(key.bytes);
    }
  }, {
    key: "hash",
    value: function hash(callback) {
      ensure(callback);
      multihashing(this.bytes, 'sha2-256', callback);
    }
    /**
     * Gets the ID of the key.
     *
     * The key id is the base58 encoding of the SHA-256 multihash of its public key.
     * The public key is a protobuf encoding containing a type and the DER encoding
     * of the PKCS SubjectPublicKeyInfo.
     *
     * @param {function(Error, id)} callback
     * @returns {undefined}
     */

  }, {
    key: "id",
    value: function id(callback) {
      this.public.hash(function (err, hash) {
        if (err) {
          return callback(err);
        }

        callback(null, bs58.encode(hash));
      });
    }
    /**
     * Exports the key into a password protected PEM format
     *
     * @param {string} [format] - Defaults to 'pkcs-8'.
     * @param {string} password - The password to read the encrypted PEM
     * @param {function(Error, KeyInfo)} callback
     * @returns {undefined}
     */

  }, {
    key: "export",
    value: function _export(format, password, callback) {
      var _this = this;

      if (typeof password === 'function') {
        callback = password;
        password = format;
        format = 'pkcs-8';
      }

      ensure(callback);
      nextTick(function () {
        var err = null;
        var pem = null;

        try {
          var buffer = new forge.util.ByteBuffer(_this.marshal());
          var asn1 = forge.asn1.fromDer(buffer);
          var privateKey = forge.pki.privateKeyFromAsn1(asn1);

          if (format === 'pkcs-8') {
            var options = {
              algorithm: 'aes256',
              count: 10000,
              saltSize: 128 / 8,
              prfAlgorithm: 'sha512'
            };
            pem = forge.pki.encryptRsaPrivateKey(privateKey, password, options);
          } else {
            err = new Error("Unknown export format '".concat(format, "'"));
          }
        } catch (_err) {
          err = _err;
        }

        callback(err, pem);
      });
    }
  }, {
    key: "public",
    get: function get() {
      if (!this._publicKey) {
        throw new Error('public key not provided');
      }

      return new RsaPublicKey(this._publicKey);
    }
  }, {
    key: "bytes",
    get: function get() {
      return pbm.PrivateKey.encode({
        Type: pbm.KeyType.RSA,
        Data: this.marshal()
      });
    }
  }]);

  return RsaPrivateKey;
}();

function unmarshalRsaPrivateKey(bytes, callback) {
  var jwk = crypto.utils.pkcs1ToJwk(bytes);
  crypto.unmarshalPrivateKey(jwk, function (err, keys) {
    if (err) {
      return callback(err);
    }

    callback(null, new RsaPrivateKey(keys.privateKey, keys.publicKey));
  });
}

function unmarshalRsaPublicKey(bytes) {
  var jwk = crypto.utils.pkixToJwk(bytes);
  return new RsaPublicKey(jwk);
}

function fromJwk(jwk, callback) {
  crypto.unmarshalPrivateKey(jwk, function (err, keys) {
    if (err) {
      return callback(err);
    }

    callback(null, new RsaPrivateKey(keys.privateKey, keys.publicKey));
  });
}

function generateKeyPair(bits, callback) {
  crypto.generateKey(bits, function (err, keys) {
    if (err) {
      return callback(err);
    }

    callback(null, new RsaPrivateKey(keys.privateKey, keys.publicKey));
  });
}

function ensure(callback) {
  if (typeof callback !== 'function') {
    throw new Error('callback is required');
  }
}

module.exports = {
  RsaPublicKey: RsaPublicKey,
  RsaPrivateKey: RsaPrivateKey,
  unmarshalRsaPublicKey: unmarshalRsaPublicKey,
  unmarshalRsaPrivateKey: unmarshalRsaPrivateKey,
  generateKeyPair: generateKeyPair,
  fromJwk: fromJwk
};